module.exports = __webpack_public_path__ + "static/media/passioni.aac4a7a6.jpg";